import { DEFAULT_LOCALE } from '../config';

export const formatElapsedTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [hours, minutes, secs]
    .map((v) => v.toString().padStart(2, '0'))
    .join(':');
};

export const formatTimeOnly = (isoString: string): string => {
  return new Date(isoString).toLocaleTimeString(DEFAULT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatTimeSpent = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  }
  return '0m';
};

export const parseTimeToSeconds = (hours: number, minutes: number): number => {
  return hours * 3600 + minutes * 60;
};

/**
 * Parses a duration string like "2h 30m", "90m", "1.5h", "2h", "30m" to seconds.
 * Returns null if the format is invalid.
 */
export const parseDurationString = (input: string): number | null => {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) return null;

  // Try parsing formats like "2h 30m", "2h30m", "2h", "30m"
  const hoursMinutesMatch = trimmed.match(/^(\d+(?:\.\d+)?)\s*h\s*(?:(\d+)\s*m)?$/);
  if (hoursMinutesMatch) {
    const hours = parseFloat(hoursMinutesMatch[1]);
    const minutes = parseInt(hoursMinutesMatch[2] || '0', 10);
    return Math.round(hours * 3600 + minutes * 60);
  }

  // Try parsing format like "30m"
  const minutesOnlyMatch = trimmed.match(/^(\d+)\s*m$/);
  if (minutesOnlyMatch) {
    const minutes = parseInt(minutesOnlyMatch[1], 10);
    return minutes * 60;
  }

  // Try parsing plain number as minutes
  const plainNumber = trimmed.match(/^(\d+)$/);
  if (plainNumber) {
    const minutes = parseInt(plainNumber[1], 10);
    return minutes * 60;
  }

  return null;
};
